module.exports = __webpack_public_path__ + "static/mobiconf-791774c014a0a43c3368ae93bacc2e25.png";